

export const actionLine = [
  {
    name: "搜索", index: 1, handler: "handleSearch",
    props: {
      type: "", size: "medium"
    }
  },
  {
    name: "重置", index: 2, handler: "clearSearch",
    props: {
      type: "", size: "medium"
    }
  },
  {
    name: "导出", index: 3, handler: "handleExport",
    props: {
      type: "primary", size: "medium"
    }
  },
];


// WEBPACK FOOTER //
// ./src/views/promote/display-idea/desc.js